import * as React from 'react';
import { connect } from 'react-redux';
import Wave from './imgs/matter/wavingHand.png'; //with import...TCDW
import ReactLogo from './imgs/AvqVxQ.png';
//import Grizzly from './imgs/matter/Logo-Sharp.png'; //with import...TCDW
import USA from './imgs/matter/usaloved.png'; //with import...TCDW
import PBJLife from './imgs/matter/PBJLife.png'; //with import...TCDW
import PDFLogo from './imgs/matter/pdfLogo.png'; //with import...TCDW
import Remotely from './imgs/matter/Remote.png'; //with import...TCDW
import SplashMe from './imgs/matter/SplashInteract.svg';

const isMobile = () => {
     let check = false;
     ( function ( a ) {
          if (
               /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
                    a.toString(),
               ) ||
               /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw(n|u)|c55\/|capi|ccwa|cdm|cell|chtm|cldc|cmd|co(mp|nd)|craw|da(it|ll|ng)|dbte|dcs|devi|dica|dmob|do(c|p)o|ds(12|d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(|_)|g1 u|g560|gene|gf5|gmo|go(\.w|od)|gr(ad|un)|haie|hcit|hd(m|p|t)|hei|hi(pt|ta)|hp( i|ip)|hsc|ht(c(| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i(20|go|ma)|i230|iac( ||\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|[a-w])|libw|lynx|m1w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|mcr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|([1-8]|c))|phil|pire|pl(ay|uc)|pn2|po(ck|rt|se)|prox|psio|ptg|qaa|qc(07|12|21|32|60|[2-7]|i)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h|oo|p)|sdk\/|se(c(|0|1)|47|mc|nd|ri)|sgh|shar|sie(|m)|sk0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h|v|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl|tdg|tel(i|m)|tim|tmo|to(pl|sh)|ts(70|m|m3|m5)|tx9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas|your|zeto|zte/i.test(
                    a.toString().substring( 0, 4 ),
               )
          )
               check = true;
     } )( navigator.userAgent || navigator.userAgent.indexOf( "Opera" ) );
     return check;
};

const SectionSet = ( {} ) => {
     if ( !isMobile() && window.innerWidth > 920 ) {
          return (
               <section id="ManageBottomTap" className="BottomAcknowledgement BottomAcknowledgement2">
                    <div className="hostedServices">
                         <p>
                              <a href="https://react.dev/learn" target="_blank">
                                   <img alt="Developed using React" src={ ReactLogo } className="hostekImg" width="190" height="110" />
                              </a>
                         </p>
                    </div>
                    <footer>
                         &copy; 2012 by Walkeramuseme and Apprehensivegent
                    </footer>
               </section>
          );
     }
     else {
          return (
               <section id="ManageBottomTap" className="BottomAcknowledgement BottomAcknowledgement2">
                    <footer>
                    </footer>
               </section>
          );
     }
}

const Home = () => (
    <div id="homeSection" className="centerConsole">
        <div className="designStaticOne"><img src={SplashMe} className="reactLogo" /></div>
        <p>Thank you, <img src={Wave} width="48" height="48" />your visit to this site is greatly appreciated; the purpose of this site is to allow some functional usage of practical applications I've built or was involved with, from independent to team-based previous assignments completed or assisted or seen.  I plan to expand my career by helping others improve their company and services while growing my businesses. <br /></p>
        <div className="myNameControlled"><h1>You can call me, Walker</h1>{/*<img src={Grizzly} width="32" height="48" />*/}</div>
        <h4>Solutions Architect/Full Stack Software Engineer</h4>
        <p>C# &#183;.Net Core &#183; AWS &#183; T-SQL &#183; Postgres SQL &#183; C++ &#183; Oracle &#183; Vue &#183; React &#183; Angular &#183; JSX &#183; JS &#183; Typescript &#183; PHP &#183; APIs &#183; Python &#183; R</p>
        <p>Working <img src={Remotely} width="24" height="24" /> remotely from <img src={USA} width="32" height="32" />to provide the most performant and solid solutions.<img src={PBJLife} width="48" height="48" /></p>
        <div className="pageNavbtn">
               <a href="https://drive.google.com/file/d/1QzdWKamTDv_6Pw7Wgkl_vij6GAWgr6wZ/view?usp=sharing" className="resume-btn" target="_blank">
                <label>
                    See My Resume<img src={PDFLogo} width="18" height="18" />
                </label>
            </a>
          </div>
          <SectionSet />
    </div>
);

export default connect()(Home);
